export const proofKinds = {
    CPARS: 'CPARS',
    ATO_LETTER: 'ATO letter',
    TEST_REPORT: 'Test report',
    PAST_PERFORMANCE: 'Past performance',
    CERTIFICATION: 'Certification',
    OTHER: 'Other'
};
export const proofKindLabel = (kind)=>proofKinds[kind] ?? kind;
